import { useTranslation } from 'react-i18next';
import { Button } from '../Buttons/Button';
import { useFreeSpins } from 'src/hooks/useFreeSpins';
import { useMemo, useRef } from 'react';
import { makeFloat, useGetCombinedGames } from 'react-easyrocket';
import { GameLoading } from 'src/components/Cards/GameLoading';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { useModalContext } from 'src/hooks/useModalContext';
import { useGameCardSize } from 'src/hooks/useGameCardSize';
import { GameCard } from '../GameCard';
import { useLocalCurrency } from 'src/hooks/useLocalCurrency';

const FreeSpinsModal = () => {
  const { t } = useTranslation();
  const { closeModal } = useModalContext();
  const parentRef = useRef<HTMLDivElement>(null);
  const { oldFreeSpins: freeSpins, setFreeSpinsChanged } = useFreeSpins();
  const { games, isFetching } = useGetCombinedGames(
    { per_page: 6 },
    {
      // category Id добавлено не из парамтеров ввиде исключения
      categoryId: 'freespins',
      target: 'games-with-freespins'
    }
  );

  const { currencyIcon } = useLocalCurrency();

  const number = useMemo(() => {
    return freeSpins?.number ? `${freeSpins?.number}` : '--';
  }, [freeSpins?.number]);

  const dayLimit = useMemo(() => {
    return freeSpins?.dayLimit ? `${freeSpins?.dayLimit}` : '--';
  }, [freeSpins?.dayLimit]);

  const betAmount = useMemo(() => {
    return freeSpins?.betAmount ? `${currencyIcon} ${makeFloat(freeSpins?.betAmount)}` : '--';
  }, [currencyIcon, freeSpins?.betAmount]);

  const numberDay = useMemo(() => {
    return freeSpins?.numberDay ? `${freeSpins?.numberDay}` : '--';
  }, [freeSpins?.numberDay]);

  const closeFreeSpinsPopUp = () => {
    closeModal();
    setFreeSpinsChanged?.(false);
  };

  const gameCardSize = useGameCardSize(parentRef.current?.clientWidth, 3);

  return (
    <ModalWrapper onClose={() => setFreeSpinsChanged?.(false)}>
      <div className="flex flex-col gap-9 p-[24px] w-[400px] r_mid:w-full">
        <div className="flex flex-col gap-7 items-center w-full">
          <div>
            <p className="font-bold text-2xl text-fp_free_spins">{t('freeSpins.freeSpins')}</p>
          </div>
          <div className="flex flex-col justify-between h-auto gap-2.5 w-full">
            <div className="flex items-center justify-between gap-20">
              <p className="text-sm font-bold w-1/2 r_sm:text-xs text-fp_free_spins_title">
                {t('freeSpins.amount')}:
              </p>
              <p className="whitespace-nowrap text-lg font-bold text-fp_free_spins_text flex-grow r_sm:text-sm">
                {number}
              </p>
            </div>
            <div className="flex items-center justify-between gap-20">
              <p className="text-sm font-bold w-1/2 r_sm:text-xs text-fp_free_spins_title">
                {t('freeSpins.limitDay')}:
              </p>
              <p className="text-lg whitespace-nowrap font-bold text-fp_free_spins_text flex-grow r_sm:text-sm">
                {dayLimit}
              </p>
            </div>
            <div className="flex items-center justify-between gap-20">
              <p className="text-sm font-bold w-1/2 r_sm:text-xs text-fp_free_spins_title">
                {t('freeSpins.betAmount')}:
              </p>
              <p className="text-lg whitespace-nowrap font-bold text-fp_free_spins_text flex-grow r_sm:text-sm">
                {betAmount}
              </p>
            </div>
            <div className="flex items-center justify-between gap-20">
              <p className="text-sm font-bold w-1/2 r_sm:text-xs text-fp_free_spins_title">
                {t('freeSpins.leftForDay')}:
              </p>
              <p className="text-lg whitespace-nowrap font-bold text-fp_free_spins_text flex-grow r_sm:text-sm">
                {numberDay}
              </p>
            </div>
          </div>
          {games?.length > 0 && (
            <div className="flex flex-col gap-3 w-full">
              <div className="ml-3">
                <p className="font-bold text-base py-0.5 text-center text-fp_games_free_spins">
                  {t('freeSpins.gameFreeSpins')}
                </p>
              </div>
              <div className="grid grid-cols-3 gap-x-2 gap-y-1 r_sm:gap-x-1" ref={parentRef}>
                {isFetching ? (
                  <GameLoading count={3} />
                ) : (
                  games.map((game) => (
                    <GameCard
                      showAddfavorite={false}
                      game={game}
                      key={game.id}
                      onClick={closeFreeSpinsPopUp}
                      {...gameCardSize}
                    />
                  ))
                )}
              </div>
            </div>
          )}
          <Button
            title={`${t('general.accept')}`}
            mode="button-primary"
            onClick={() => {
              closeModal();
              setFreeSpinsChanged?.(false);
            }}
            label={`${t('general.accept')}`}
          />
        </div>
      </div>
    </ModalWrapper>
  );
};

export default FreeSpinsModal;
